module.exports = __webpack_public_path__ + "static/media/IMG_0001.bd3bd7bb.jpg";